'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _components = require('../../../components');

var _urls = require('../../../utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AllAuctions = require('./AllAuctions.scss');

var _AllAuctions2 = _interopRequireDefault(_AllAuctions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AllAuctions = function (_Component) {
    (0, _inherits3.default)(AllAuctions, _Component);

    function AllAuctions() {
        (0, _classCallCheck3.default)(this, AllAuctions);
        return (0, _possibleConstructorReturn3.default)(this, (AllAuctions.__proto__ || (0, _getPrototypeOf2.default)(AllAuctions)).apply(this, arguments));
    }

    (0, _createClass3.default)(AllAuctions, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                parent = _props.parent;


            var links = [(0, _jsx3.default)('a', {
                className: _AllAuctions2.default.link,
                href: baseUrl + '/catalog/search?parameters=%7B%22page%22%3A1%2C%22pageSize%22%3A120%2C%22catalog_status%22%3A%22live%2Conline%22%7D'
            }, 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_calendar'
            }), (0, _jsx3.default)(_caterwaulComponents.Icon, {
                name: 'calendar',
                className: _AllAuctions2.default.calendar
            })), (0, _jsx3.default)(_components.Link, {
                className: _AllAuctions2.default.link,
                route: true,
                to: '/find-auctions-near-me'
            }, 1, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctions_near_me'
            })), (0, _jsx3.default)(_components.Link, {
                className: _AllAuctions2.default.link,
                route: true,
                to: (0, _urls.getAuctioneerDirectoryUrl)()
            }, 2, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_house_directory'
            })), (0, _jsx3.default)(_components.Link, {
                className: _AllAuctions2.default.link,
                route: true,
                to: (0, _urls.getAuctionResultsUrl)()
            }, 3, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'past_auction_results'
            }))];

            var title = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'all_auctions'
            });

            return (0, _jsx3.default)(_components.DropDownMenu, {
                baseUrl: baseUrl,
                links: links,
                parent: parent,
                placement: 'bottom',
                title: title,
                titleClass: _AllAuctions2.default['auction-title'],
                dropdownClass: _AllAuctions2.default.aDropDown
            });
        }
    }]);
    return AllAuctions;
}(_react.Component);

exports.default = AllAuctions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation/AllAuctions.js
// module id = fR6t
// module chunks = 46